<template>
    <div>
        <h5>{{'Notes' | language}}</h5>
        <div v-html="language === 'english' ? property.str_highlights_en : property.str_highlights_jp"></div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: 'listing-description',
        props: {
            property: Object
        },
        computed: {
          ...mapState({
              language: (state) => {
                  return state.general.language
              }
          })
      },
    }
</script>

<style>
</style>
